import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    ",
        " {\n      flex-direction: row;\n      justify-content: center;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var ResponsiveWrapper = /*#__PURE__*/ styled("div", {
    target: "e1lqi4030"
})("display:flex;flex-direction:column;gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";", function(param) {
    var theme = param.theme;
    return css(_templateObject(), theme.mq("xl"));
});
export { ResponsiveWrapper };
